import { render } from "./DateMarker.vue?vue&type=template&id=a286d9ea&ts=true"
import script from "./DateMarker.vue?vue&type=script&lang=ts"
export * from "./DateMarker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/DateMarker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a286d9ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a286d9ea', __exports__)) {
    api.reload('a286d9ea', __exports__)
  }
  
  module.hot.accept("./DateMarker.vue?vue&type=template&id=a286d9ea&ts=true", () => {
    api.rerender('a286d9ea', render)
  })

}


export default __exports__